var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"acquisition-page h-100",staticStyle:{"padding-top":"80px"}},[_c('blog-acf-blocks',{staticClass:"roboto-font h-100"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }